import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { Home, Mail, Sparkles } from "lucide-react";
import logo from '../images/ealogo2.png';

const Navbar = () => {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <motion.nav
            className="sticky top-0 z-50 bg-white backdrop-blur-xl border-b border-border/50 shadow-lg"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
        >
            <div className="max-w-7xl mx-auto px-6 py-4">
                <div className="flex items-center justify-between">
                    <motion.div
                        className="flex items-center space-x-3"
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: "spring", stiffness: 400, damping: 25 }}
                    >
                        <Link to="/" className="flex items-center space-x-3 group">
                            <div className="relative">
                                <img src={logo} className="h-12 w-auto transition-all duration-300 group-hover:scale-110" alt="Express Analytics" />
                                <motion.div
                                    className="absolute -inset-2 bg-gradient-to-r rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                    animate={{
                                        scale: [1, 1.1, 1],
                                        opacity: [0.5, 0.8, 0.5],
                                    }}
                                    transition={{
                                        duration: 2,
                                        repeat: Infinity,
                                        ease: "easeInOut"
                                    }}
                                />
                            </div>
                            {/* <motion.div
                                className="hidden md:block"
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.2 }}
                            >
                                <h1 className="text-xl font-bold gradient-text bg-gradient-to-r from-accent to-primary bg-clip-text text-transparent">
                                    Express Analytics
                                </h1>
                                <p className="text-xs text-muted-foreground">Data Science Platform</p>
                            </motion.div> */}
                        </Link>
                    </motion.div>

                    <div className="flex items-center space-x-2">
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Button
                                variant={isActive('/') ? 'gradient' : 'ghost'}
                                size="sm"
                                asChild
                                className="rounded-full text-black relative overflow-hidden group"
                            >
                                <Link to="/" className="flex items-center space-x-2">
                                    <Home className="w-4 h-4" />
                                    <span>Home</span>
                                    {isActive('/') && (
                                        <motion.div
                                            className="absolute inset-0 bg-gradient-to-r from-accent/20 to-primary/20 rounded-full"
                                            layoutId="activeTab"
                                            transition={{ type: "spring", stiffness: 500, damping: 30 }}
                                        />
                                    )}
                                </Link>
                            </Button>
                        </motion.div>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Button
                                variant={isActive('/contact') ? 'gradient' : 'ghost'}
                                size="sm"
                                asChild
                                className="rounded-full text-black relative overflow-hidden group"
                            >
                                <Link to="/contact" className="flex items-center space-x-2">
                                    <Mail className="w-4 h-4" />
                                    <span>Contact</span>
                                    {isActive('/contact') && (
                                        <motion.div
                                            className="absolute inset-0 bg-gradient-to-r from-accent/20 to-primary/20 rounded-full"
                                            layoutId="activeTab"
                                            transition={{ type: "spring", stiffness: 500, damping: 30 }}
                                        />
                                    )}
                                </Link>
                            </Button>
                        </motion.div>

                        {/* Decorative element */}
                        {/* <motion.div
                            className="hidden md:flex items-center space-x-2 ml-4 px-3 py-2 bg-gradient-to-r from-accent/10 to-primary/10 rounded-full border border-accent/20"
                            animate={{
                                boxShadow: [
                                    "0 0 20px hsl(var(--accent)/0.1)",
                                    "0 0 30px hsl(var(--accent)/0.2)",
                                    "0 0 20px hsl(var(--accent)/0.1)"
                                ]
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                        >
                            <Sparkles className="w-4 h-4 text-accent" />
                            <span className="text-xs font-medium text-accent">AI Powered</span>
                        </motion.div> */}
                    </div>
                </div>
            </div>
        </motion.nav>
    );
};

export default Navbar;